import { useOfferById } from "@features/offers"
import useEnv from "hooks/useEnv"
import { Trans } from "react-i18next"
import { useParams } from "react-router-dom"
import PostsGea from "./components/PostsGea"
import PostsGeabrasil from "./components/PostsGeabrasil"
import PostsGecontur from "./components/PostsGecontur"

function Post() {
  const { isGecontur, isGeaBrasil } = useEnv()
  const { offerId } = useParams<Record<string, string | undefined>>()
  const offer = useOfferById(offerId)

  if (!offer) {
    return (
      <div>
        <Trans i18nKey="offersPost.notFound.title" />
      </div>
    )
  }

  if (isGecontur) {
    return <PostsGecontur offer={offer} />
  }

  if (isGeaBrasil) {
    return <PostsGeabrasil offer={offer} />
  }

  return <PostsGea offer={offer} />
}

export default Post
